import { Coffee, Dices, HeartHandshake, Medal, Monitor, MonitorPlay, Star, Trophy, Tv, UserPlus } from "lucide-react";
import Reveal from "./Reveal";
import { SERVICES } from "../data/siteData";

const ICONS = { Trophy, Medal, Tv, UserPlus, HeartHandshake, Dices, MonitorPlay, Star, Monitor, Coffee };

export default function ServiceGrid({ compact = false }) {
  const catalog = SERVICES.filter((s) => s.catalog !== false);
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {catalog.map((s, i) => {
        const Icon = ICONS[s.icon] || Trophy;
        return (
          <Reveal key={s.id} delay={i * 0.06}>
            <div
              data-testid={`service-card-${s.id}`}
              className="card-soft group h-full p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_-10px_rgba(0,168,89,0.18)]"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-light text-brand-dark transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                <Icon className="h-6 w-6" />
              </span>
              <h3 className="mt-4 font-display text-lg font-bold uppercase tracking-tight text-ink">
                {s.title}
              </h3>
              {!compact && (
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
              )}
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}
